let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9UmSD")).then(() => parcelRequire('9vAtn'));